import React, { useState, useEffect, useRef } from "react";

import {
  Button,
  Dialog,
  Grid,
  Icon,
  Typography,
  FormHelperText,
  TextField,
  IconButton
} from "@material-ui/core";
// import Chip from '@material-ui/core/Chip';
// import { makeStyles } from '@material-ui/core/styles';
import Scrollbars from "rc-scrollbars";
import CloseIcon from "@material-ui/icons/Close";
import DialogLoader from "../../../../../../../components/Loader/DialogLoader";
import {
  InputBaseField, MultiSelectField, FileInput, SelectField
} from "../../../../../../../components/InputField/InputField";
import {
  Label,
  DraggableComponent,
} from "../../../../../../../components/UiElements/UiElements";
import { PostDataAPI } from "../../../../../../../Services/APIService";
import { withSnackbar } from "../../../../../../../components/Message/Alert";
import useStyles from "./styles";

import {
  allowedAttachmentsImages
} from "../../../../../../../../src/components/Common/Extensions";

import PreviewIcon from '@material-ui/icons/Visibility';

function AddNewAddress({
  organizationId,
  dialogOpenClose,
  editProgram,
  handleClose,
  handleSuccessClose,
  ...props
}) {
  const classes = useStyles();
  // const classes1 = useStyles1();
  const [isLoading, setIsLoading] = useState(false);
  const [state, setState] = useState([]);
  const [errorMessages, setErrorMessages] = useState({
    errorNote: false,
    errorEditorMaxValue: false,
  });

  const { showMessage } = props;

  const handleChange = (e) => {

    const { name, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const commonAttachments = allowedAttachmentsImages();
  const [documentFile, setDocumentFile] = useState([]);
  const inputFile = useRef(null);

  function uploadSingleFile(e) {
    if (e.target.files == null || e.target.files.length <= 0) return;

    const selectedFile = e.target.files[0];

    // Check if the file is already present in bannerImage
    if (documentFile.some((file) => file.fileToSend.name === selectedFile.name)) {
      showMessage('Error', 'File already added', 'error', 3000);
      // Clear the input value to allow reselection of the same file
      e.target.value = null;
      return;
    }

    const name = selectedFile.name;
    const lastDot = name.lastIndexOf('.');
    const ext = name.substring(lastDot + 1);

    switch (ext) {
      case 'pdf':
      case 'doc':
      case 'docx':
        break;
      default:
        showMessage(
          'Error',
          'File format is not allowed,\n Only files with the following extensions are allowed: .pdf .doc .docx',
          'error',
          3000
        );
        // Clear the input value to prevent adding an invalid file
        e.target.value = null;
        return;
    }

    setDocumentFile((prev) => [
      ...prev,
      {
        fileToSend: selectedFile,
        FileName: selectedFile.name,
        FileSubType: state.documentType
      },
    ]);
    // Clear the input value to allow adding the same file again
    e.target.value = null;
  }

  const handleRemoveFile = (index) => {
    const newFileList = [...documentFile];
    newFileList.splice(index, 1);
    setDocumentFile(newFileList);
  };


  console.log(documentFile, 'tjis is ;lk')


  const Validate = (errorList) => {
    if (!state.documentType) {
      setErrorMessages((prevState) => ({
        ...prevState,
        errorDocumentType: true,
      }));
      errorList.push(true);
    } else {
      setErrorMessages((prevState) => ({
        ...prevState,
        errorDocumentType: false,
      }));
    }
    if (documentFile.length == 0 && documentFile.fileToSend == null) {
      setErrorMessages((prevState) => ({
        ...prevState,
        errorDocumentFile: true,
      }));
      errorList.push(true);
    } else {
      setErrorMessages((prevState) => ({
        ...prevState,
        errorDocumentFile: false,
      }));
    }
  };




  const addPhotos = () => {
    debugger
    let errorList = [];
    Validate(errorList);

    if (errorList.length > 0) return;

    const formData = new FormData();

    formData.append("donorId", organizationId);
    formData.append("Type", "Program Documentation");
    formData.append("SubType", state.documentType);
    formData.append("Category", "Organization");
    formData.append("Description", "Signed strategic plan for program funding.");

    // Attach files
    // documentFile.forEach((fileObj, index) => {
    //   formData.append("AttachmentFiles", fileObj.fileToSend);
    // });

    for (const element of documentFile) {
      formData.append("AttachmentFiles", element.fileToSend);
    }


    setIsLoading(true);

    PostDataAPI("fdngrantattachments/add", formData, true, "multipart/form-data")
      .then((result) => {
        setIsLoading(false);

        if (result.success && result.data) {
          handleSuccessClose("Document uploaded successfully.");
        } else {
          showMessage("Error", result.message, "error", 3000);
        }
      });

  }
  const documentType = [
    {
      label: "Select Document Type",
      value: ""
    }, ,
    {
      label: "Proposal Documents",
      value: "Proposal Documents"
    },
    {
      label: "Strategic Plans",
      value: "Strategic Plans"
    }
  ]



  useEffect(() => {
    if (editProgram) {
    }
  }, []);

  return (
    <Dialog
      classes={{ paper: classes.dialogPaper }}
      PaperComponent={DraggableComponent}
      disableBackdropClick
      disableEscapeKeyDown
      open={dialogOpenClose}
      maxWidth="lg"
      {...props}
    >
      <div className={classes.dialogContent}>
        <div className={classes.box}>
          <div className={classes.header} id="draggable-dialog-title">
            <Typography className={classes.title}>Add Document</Typography>

            <Icon
              className={classes.closeIcon}
              onClick={handleClose}
              color="primary"
            >
              <CloseIcon />
            </Icon>
          </div>

          {isLoading ? <DialogLoader></DialogLoader> : ""}
          <Scrollbars autoHeight autoHeightMax={570}>
            <div className={classes.content}>



              <Grid container>

                <Grid item sm={12} md={12} lg={12}>

                  <Label size={12} title="Document Type" mandatory={true} />
                  <div className={classes.BrowseMain}>

                    <SelectField
                      name="documentType"
                      id="documentType"
                      options={documentType}
                      onChange={handleChange}
                      value={state.documentType}

                    />
                    {errorMessages.errorDocumentType && !state.documentType ? (<FormHelperText style={{ color: "red" }} >
                      Please select document type
                    </FormHelperText>) : ('')}

                  </div>
                </Grid>

                <Grid item sm={12} md={12} lg={12} xl={12}>
                  <Label size={12} title="Add Document" mandatory={true} />
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <input
                      ref={inputFile}
                      id="bannerImg"
                      name="bannerImg"
                      type="file"
                      IsDisabled={false}
                      MaxLength={80}
                      style={{ display: 'none' }}
                      onChange={uploadSingleFile}
                    />
                    <div className={classes.BrowseMain}>
                      <InputBaseField
                        type="text"
                        value={documentFile.fileName}
                        placeholder="Please Select your file here"
                        MaxLength={80}
                        className={classes.fileInput}
                        readOnly={true}
                        onPaste={(e) => e.preventDefault()}
                        onDrop={(e) => e.preventDefault()}
                      />
                      <a onClick={() => inputFile.current.click()} className={'BrowseButton'}>
                        Browse
                      </a>
                    </div>
                    {errorMessages.errorDocumentFile && documentFile.length == 0 ? (
                      <FormHelperText style={{ color: 'red' }}>Please Select your file</FormHelperText>
                    ) : (
                      ''
                    )}
                    <Typography>Accepted formats: .doc, .docx, .pdf</Typography>
                    {documentFile.length > 0 && (
                      <div className={classes.fileList}>
                        {documentFile.map((file, index) => (
                          <div key={index} className={classes.fileName}>
                            {file.FileName}
                            <div>
                              <IconButton className={classes.IconBg} onClick={() => handleRemoveFile(index)}>
                                <CloseIcon className={'IconColor'} />
                              </IconButton>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </Grid>

                </Grid>
              </Grid>
            </div>
          </Scrollbars>
          <div className={classes.footer}>
            <div className={classes.footerRight}>
              <Button className={classes.backBtn} onClick={handleClose}>
                Close
              </Button>
              <Button onClick={addPhotos} className={classes.changeBtn} >
                Save
              </Button>
            </div>
          </div>
        </div>
      </div >
    </Dialog >
  );
}

export default withSnackbar(AddNewAddress);
